export default class Color{
    static PRIMARY:string = "primary";
    static PURPLE:string = "purple";
    static GREY:string = "grey";
    static WHITE:string = "white";
    static WHITE_PRIMARY:string = "whitePrimary";
    static TRANSPARENT:string = "transparent";
    static TRANSPARENT_PRIMARY:string = "transparentPrimary";
    static GREEN:string = "green";
    static YELLOW:string = "yellow";
    static BLUE:string = "blue";
    static RED:string = "red";
    static BLUE_PRIMARY:string = "bluePrimary";
    static RED_PRIMARY:string = "redPrimary";

}